// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3be93c79","451":"660d8f44"}[chunkId] + ".chunk.js";
};